import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css'
import { Link, useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import GetPagePermission from '../components/GetPagePermission'
import { formatDecimalQuantity } from '../helpers/GlobalHelper'

function WorkInProgressList() {
	const hasPermission = GetPagePermission('/work-in-progress')
	const canStartQc = GetPagePermission('/wip-qc')
	const canPackingOrders = GetPagePermission('/packing-orders')
	const history = useHistory()

	const startQc = async (id: number) => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to start QC for this blending order?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Start QC',
		})
		if (!confirm.isConfirmed) {
			return
		}

		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}blending-orders/start-qc/${id}`,
				postRequestOptions({})
			)
			const data = await response.json()
			if (data.success) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: data.successMessage,
				}).then(() => history.push(`/work-in-progress-details/${id}`))
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: data.errorMessage || data.errors || 'Action failed.',
				})
			}
		} catch (error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'An error occurred.',
			})
		}
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'productionOrderNo', title: 'Production Order No', style: { textAlign: 'left' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'productionDate', title: 'Production Date', style: { textAlign: 'left' } },
		{ value: 'productName', title: 'Product', style: { textAlign: 'left' } },
		{ value: 'productionQuantity', title: 'Blending Qty', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.productionQuantity) },
		{ value: 'alreadyUsed', title: 'Already Used', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.alreadyUsed) },
		{ value: 'remainingQty', title: 'Remaining Qty', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.remainingQty) },
		{ value: 'weightInKg', title: 'Weight KG', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.weightInKg) },
		{ value: 'batchNo', title: 'Batch No', style: { textAlign: 'left' } },
		{ value: 'status', title: 'Status', style: { textAlign: 'left' } },
		{ value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'left', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: ((row: any) => {
				return (
					<>
						<Link className="btn btn-light-primary btn-sm me-1" to={`/work-in-progress-details/${row.id}`}>
							<KTSVG
								path="/media/svg/icons/Layout/Layout-grid.svg"
								className="svg-icon-5 svg-icon"
							/>		Details
						</Link>
						{row.status === 'WIP' && canStartQc === 1 &&
							<button
								type="button"
								className="btn btn-light-warning btn-sm me-1"
								onClick={() => startQc(row.id)}
							>
								Start QC
							</button>
						}
						{row.status === 'QC Passed' && canPackingOrders === 1 && Number(row.remainingQty) > 0 &&
							<Link className="btn btn-light-success btn-sm me-1" to={`/packing-order-create/${row.id}`}>
								Create Packing Order
							</Link>
						}
					</>
				)
			}),
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		productionOrderNo: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		productionDate: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		productionQuantity: { filterType: 'like', filterValue: '' },
		alreadyUsed: { filterType: 'like', filterValue: '' },
		remainingQty: { filterType: 'like', filterValue: '' },
		weightInKg: { filterType: 'like', filterValue: '' },
		batchNo: { filterType: 'like', filterValue: '' },
		status: { filterType: 'like', filterValue: '' },
		createdBy: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'work-in-progress/dt'

	return (
		<>
			{hasPermission === 1 &&
				<div className="card card-custom">
					<div className="card-header">
						<div className="card-title">
							<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
							<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
								Work In Progress
							</span>
						</div>
					</div>

					<div className="card-body">
						<DataTable url={url} columns={columns} filters={filters} />
					</div>
				</div>
			}
		</>
	)
}

export default WorkInProgressList
